module.exports = __webpack_public_path__ + "fonts/Inter-900-latin-ext65.fad2a54.woff2";